import { WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { push } from 'connected-react-router';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { funcClose } from '../utils/StartupUtils';

import i18n from 'src/resources/i18n';
import { UpwardTransition } from 'src/utils';

import { isMobile } from 'src/utils/MobileCheck';

import { commonHandleShowErrorMessage } from 'src/actions/common';
import {
	setAdmintFlg,
	setELearningPage,
	setNextBtnDisFlg,
} from 'src/actions/eLearning';

import { IRootState } from 'src/reducers';

import ScenarioFactory, {
	IEndELearningTextParam,
	IFetchELearningTreeParam,
	IStartELearningTextParam,
} from 'src/scenario/ELearningScenarioFactory';

import ELearningContentsApiSetter from 'src/components/ELearningContentsApiSetter';

import { IELearningCommonProps } from './ELearning';

import SiteConfig from '../site.config.json';

const styles = (theme: Theme) =>
	createStyles({
		frame: {
			display: 'inline-flex',
			overflow: 'auto !important',
			width: '100%',
			['-webkit-overflow-scrolling']: 'touch !important',
		},
	});

interface IState {
	isShowConfirmFinish: boolean;
}

/**
 * eラーニングテキスト表示
 */
class ELearningText extends React.Component<IProps, IState> {
	protected elmIframe: React.RefObject<HTMLIFrameElement>;
	protected elmParent: React.RefObject<HTMLDivElement>;
	protected elmForm: React.RefObject<HTMLFormElement>;
	protected elmMediaSiteApiStatus: React.RefObject<HTMLInputElement>;
	protected mediasiteTimer?: number;

	protected resizeFrameWrapper: () => void;

	public constructor(props: IProps) {
		super(props);
		this.state = {
			isShowConfirmFinish: false,
		};
		this.elmIframe = React.createRef();
		this.elmParent = React.createRef();
		this.elmForm = React.createRef();
		this.elmMediaSiteApiStatus = React.createRef();
	}

	/**
	 * Lifecycle Methods
	 */
	public async componentDidMount() {
		if (!this.props.currentTreeItem || this.props.outOfPeriodFlg) {
			return;
		}

		const topicID = this.props.currentTreeItem.id;
		const pageCount = this.props.currentTreeItem.pageCount;
		// AdmintTV情報データ取得
		await this.fetchELearningTextAdmintResult();
		this.loadContent();
		// 受講開始
		this.props.startELearningText(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			isMenu: true,
			isPreview: this.props.preview,
			page: this.props.currentPage,
			pageCount,
			topicID,
			userAttr: this.props.userAttr,
		});
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUpdate(nextProps: IProps) {
		if (!this.props.currentTreeItem) {
			return;
		}
		if (
			nextProps.currentTreeItem &&
			this.props.currentTreeItem.id === nextProps.currentTreeItem.id
		) {
			return;
		}

		// 別のテキストに移動しようとしているため現在のテキストは受講終了
		this.endELearningText();
	}

	/**
	 * Lifecycle Methods
	 */
	public async componentDidUpdate(prevProps: IProps) {
		if (!prevProps.currentTreeItem || !this.props.currentTreeItem) {
			return;
		}

		if (!prevProps.showFinishDialog && this.props.showFinishDialog) {
			// 受講終了
			this.endELearningText();
		}

		if (prevProps.currentTreeItem.id !== this.props.currentTreeItem.id) {
			// テキストから違うテキストに遷移したときここにくる
			this.endELearningText();
			await this.fetchELearningTextAdmintResult();
			this.loadContent();
			return;
		}
		if (prevProps.currentPage !== this.props.currentPage) {
			// ページがかわった
			await this.fetchELearningTextAdmintResult();
			this.loadContent();
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		if (this.mediasiteTimer !== undefined) {
			clearTimeout(this.mediasiteTimer);
		}

		if (!this.props.currentTreeItem) {
			return;
		}

		if (this.resizeFrameWrapper) {
			const type = isMobile() ? 'orientationchange' : 'resize';
			window.removeEventListener(type, this.resizeFrameWrapper);
		}

		// 受講終了
		this.endELearningText();
		// 目次からテキスト->アンケートなどに移動するの場合、次へボタンを有効化
		process.nextTick(() => {
			this.props.setNextBtnDisFlg(false);
		});
	}

	public render() {
		const {
			classes,
			careerID,
			classID,
			mediaSiteApiStatus,
			currentPage,
			userAttr,
			preview,
		} = this.props;

		if (!this.props.currentTreeItem) {
			return;
		}
		if (this.props.outOfPeriodFlg) {
			return <React.Fragment />;
		}

		const topicID = this.props.currentTreeItem.id;
		const pageCount = this.props.currentTreeItem.pageCount;

		const exitHandler = this.handleOpenConfirmFinish;
		const nextHandler = this.handleNext;
		const previousHandler = this.handlePrev;
		const toggleIndexHandler = this.handleShowIndexTree;

		return (
			<div className={classes.frame} ref={this.elmParent}>
				<ELearningContentsApiSetter
					exitHandler={exitHandler}
					nextHandler={nextHandler}
					previousHandler={previousHandler}
					toggleIndexHandler={toggleIndexHandler}
				/>
				<form
					method="POST"
					action={
						SiteConfig.tsqPath + '/tsq/pkg/action/el/text.action'
					}
					target="eLearning"
					ref={this.elmForm}
				>
					<iframe name="nodispframe" style={{ display: 'none' }} />
					<input type="hidden" name="topicID" value={topicID} />
					<input type="hidden" name="page" value={currentPage} />
					<input type="hidden" name="pageCount" value={pageCount} />
					<input type="hidden" name="careerID" value={careerID} />
					<input type="hidden" name="lang" value={userAttr.lang} />
					<input
						type="hidden"
						name="userId"
						value={userAttr.userId}
					/>
					<input
						type="hidden"
						name="viewMode"
						value={preview ? '1' : '0'}
					/>
					<input type="hidden" name="classID" value={classID} />
					<input
						type="hidden"
						name="accessType"
						value={preview ? '21' : '10'}
					/>
					<input
						type="hidden"
						name="mediaSiteApiStatus"
						value={mediaSiteApiStatus}
						ref={this.elmMediaSiteApiStatus}
					/>
					<input
						type="hidden"
						name="admintFlg"
						value={this.props.admintFlg}
					/>
				</form>
				<iframe
					ref={this.elmIframe}
					frameBorder="0"
					title={i18n.t('ELearningText_0001')}
					name="eLearning"
				/>
				<Dialog
					open={this.state.isShowConfirmFinish ? true : false}
					TransitionComponent={UpwardTransition}
					keepMounted={true}
					onClose={this.handleCloseConfirmFinish}
					aria-labelledby="alert-dialog-slide-title"
					aria-describedby="alert-dialog-slide-description"
				>
					<DialogTitle id="alert-dialog-slide-title">
						{i18n.t('Ebar_0004')}
					</DialogTitle>
					<DialogContent>
						{preview ? (
							<DialogContentText id="alert-dialog-slide-description">
								{i18n.t('Ebar_0005')}
							</DialogContentText>
						) : (
							<DialogContentText id="alert-dialog-slide-description">
								{i18n.t('Ebar_0006')}
							</DialogContentText>
						)}
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleFinish} color="primary">
							{i18n.t('Ebar_0007')}
						</Button>
						<Button onClick={this.handleCloseConfirmFinish}>
							{i18n.t('Ebar_0008')}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}

	protected async fetchELearningTextAdmintResult() {
		if (!this.props.currentTreeItem || this.props.outOfPeriodFlg) {
			return;
		}
		const topicID = this.props.currentTreeItem.id;
		const pageCount = this.props.currentTreeItem.pageCount;
		// AdmintTV情報データ取得
		await this.props
			.setELearningTextAdmintResult(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isMenu: false,
				isPreview: this.props.preview,
				page: this.props.currentPage,
				pageCount,
				topicID,
				userAttr: this.props.userAttr,
			})
			.catch(e => {
				// handle network error
				commonHandleShowErrorMessage({
					content: e.messageKey,
					replacements: [],
				});
				this.props.setAdmintFlg('1');
			});
	}

	/**
	 * リサイズハンドラ
	 */
	protected resizeFrame() {
		const innerHeight =
			window.innerHeight || document.documentElement.clientHeight;
		if (!(this.elmParent.current && this.elmIframe.current)) {
			return;
		}
		const rect = this.elmIframe.current.getBoundingClientRect();
		this.elmIframe.current.width = this.elmParent.current.offsetWidth.toString();
		this.elmIframe.current.height = (
			innerHeight -
			(rect.top - window.pageYOffset) -
			8
		).toString();
	}

	/**
	 * eラーニングページ読み込み
	 */
	protected loadContent() {
		if (this.props.outOfPeriodFlg) {
			return;
		}

		if (this.mediasiteTimer !== undefined) {
			clearTimeout(this.mediasiteTimer);
			this.mediasiteTimer = undefined;
		}
		if (!this.elmIframe.current) {
			return;
		}
		const iframe = this.elmIframe.current;

		if (!this.props.currentTreeItem) {
			return;
		}
		if (!this.elmForm.current) {
			return;
		}
		this.elmForm.current.submit();
		// 受講画面が読み込みの状態を有効化
		this.props.setProgressLoadingFlg(true);
		if (!iframe.onload) {
			iframe.onload = () => {
				this.processAdmint(iframe);
				this.processMediasite(iframe);
				this.resizeFrame();
				if (!this.resizeFrameWrapper) {
					this.resizeFrameWrapper = () => {
						this.resizeFrame();
					};
					const type = isMobile() ? 'orientationchange' : 'resize';
					window.addEventListener(type, this.resizeFrameWrapper);
				}
				this.props
					.fetchELearningTree(this.props.token, {
						careerID: this.props.careerID,
						classID: this.props.classID,
						isPreview: this.props.preview,
						userAttr: this.props.userAttr,
					})
					.then(() => {
						// ツリー情報を受取り、ツリー情報が更新完了時、次へボタンを有効化
						this.props.setNextBtnDisFlg(false);
					})
					.catch(e => {
						// サーバ側が異常発生の場合、次へボタンを有効化
						this.props.setNextBtnDisFlg(false);
						throw e;
					})
					.finally(() => {
						// 受講画面が読み込みの状態を表示しない
						this.props.setProgressLoadingFlg(false);
					});
			};
		}
	}

	/**
	 * メディアサイト処理<br />
	 * --テキストがメディアサイトが判定し、メディアサイトの場合監視処理を開始する
	 * @param iframe
	 */
	protected processMediasite(iframe: HTMLIFrameElement) {
		if (!iframe.contentDocument) {
			return;
		}
		const metaElements = iframe.contentDocument.getElementsByTagName(
			'meta'
		);
		let author = '';
		let description = '';
		// tslint:disable-next-line:prefer-for-of
		for (let i = 0; i < metaElements.length; i++) {
			const element = metaElements[i];
			if (element.name === 'author') {
				author = element.content;
			}
			if (element.name === 'description') {
				description = element.content;
			}
		}
		// メディアサイトテンプレートか？
		if (
			author !== 'Generalist/LW' ||
			description !== 'eLearning-Template-Page'
		) {
			return;
		}

		this.props.onChangePlayerStatus(true);
		this.mediasiteTimer = window.setTimeout(() => {
			this.updateMediasiteStatus();
		}, 1000);
	}

	/**
	 * AdmintTV連携処理
	 * --AdmintTV連携の場合、iframe領域のロード時動画視聴画面URLを登録する。
	 * @param iframe
	 */
	protected processAdmint(iframe: HTMLIFrameElement) {
		if (!iframe.contentDocument) {
			return;
		}
		if (this.props.admintFlg === '1') {
			iframe.contentDocument.getElementsByTagName('body')[0].innerHTML =
				"<iframe src='" + this.props.admintUrl + "'>";
		}
	}

	/**
	 * メディアサイト状態更新
	 */
	protected updateMediasiteStatus = () => {
		if (
			!this.elmIframe.current ||
			!this.elmIframe.current.contentDocument
		) {
			return;
		}

		const document = this.elmIframe.current.contentDocument;
		const srcElement = document.getElementById(
			'mediaSiteApiStatus'
		) as HTMLInputElement;
		const mediaSiteApiStatus = srcElement ? srcElement.value : null;

		if (mediaSiteApiStatus === 'playerError') {
			// エラーの場合は監視を停止
			return;
		}

		if (mediaSiteApiStatus === 'mediaEnded') {
			// 視聴完了（mediaEnded）の場合)
			if (!this.elmMediaSiteApiStatus.current || !this.elmForm.current) {
				return;
			}

			// メディアサイト動画再生終了をsubmit
			this.elmMediaSiteApiStatus.current.value = mediaSiteApiStatus;
			const { attributes } = this.elmForm.current;
			const target = document.createAttribute('target');
			target.value = 'nodispframe';
			attributes.setNamedItem(target);
			this.elmForm.current.submit();

			this.props.onChangePlayerStatus(false);
			return;
		}

		this.mediasiteTimer = window.setTimeout(() => {
			this.updateMediasiteStatus();
		}, 1000);
	};

	/**
	 * 前へボタンクリックハンドラ
	 */
	protected handlePrev = async () => {
		if (this.props.disabledPrev) {
			this.props.handlePrevQuestion();
		}
	};

	/**
	 * 次へボタンクリックハンドラ
	 */
	protected handleNext = async () => {
		if (this.props.disabledNext) {
			this.props.handleNextQuestion();
		}
	};

	/**
	 * 目次表示ハンドラ
	 */
	protected handleShowIndexTree = async () => {
		this.props.handleShowIndexTree();
	};

	/**
	 * eラーニングテキスト終了
	 */
	protected endELearningText() {
		if (!this.props.currentTreeItem || this.props.outOfPeriodFlg) {
			return;
		}

		// 受講終了
		const topicID = this.props.currentTreeItem.id;
		const pageCount = this.props.currentTreeItem.pageCount;
		this.props.endELearningText(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			isPreview: this.props.preview,
			page: this.props.currentPage,
			pageCount,
			startTime: this.props.startTime,
			topicID,
			userAttr: this.props.userAttr,
		});
	}

	/**
	 * 受講終了確認ダイアログオープンハンドラ
	 */
	protected handleOpenConfirmFinish = async () => {
		this.setState({ isShowConfirmFinish: true });
	};

	/**
	 * 受講終了確認ダイアログクローズハンドラ
	 */
	protected handleCloseConfirmFinish = () => {
		this.setState({ isShowConfirmFinish: false });
	};

	/**
	 * 受講終了ハンドラ
	 */
	protected handleFinish = () => {
		const portalFlg = localStorage.getItem('portalFlg');
		if (portalFlg === '0') {
			funcClose();
			return;
		}
		this.setState({ isShowConfirmFinish: false });
		if (this.props.preview) {
			// eラーニング閲覧のとき
			if (window.opener && window.opener.closed === false) {
				// 呼び出し元ウィンドウが生きている場合はそちらで処理してもらう
				window.opener.postMessage('endpreview', '*');
			}
			return;
		}
		this.props.pushHistory(this.props.caller);
	};
}

const mapStateToProps = (state: IRootState) => ({
	admintFlg: state.eLearning.admintFlg,
	admintUrl: state.eLearning.admintUrl,
	currentPage: state.eLearning.currentPage,
	currentTreeItem: state.eLearning.currentTreeItem,
	indexTree: state.eLearning.indexTree,
	mediaSiteApiStatus: state.eLearning.mediaSiteApiStatus,
	showFinishDialog: state.eLearning.showFinishDialog,
	startTime: state.eLearning.startTime,
	token: state.session.token,
	userAttr: state.session.userAttr,
	viewMode: state.eLearning.viewMode,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	endELearningText: (token: string, arg: IEndELearningTextParam) => {
		const s = ScenarioFactory.createEndELearningText(dispatch, token);
		s.run(arg);
	},
	fetchELearningTree: (token: string, arg: IFetchELearningTreeParam) => {
		const s = ScenarioFactory.createFetchELearningTree(dispatch, token);
		return s.run(arg);
	},
	setELearningPage: (page: number) => dispatch(setELearningPage({ page })),

	setAdmintFlg: (admintFlg: string) => dispatch(setAdmintFlg({ admintFlg })),
	setELearningTextAdmintResult: (
		token: string,
		arg: IStartELearningTextParam
	) => {
		const s = ScenarioFactory.createAdmintResult(dispatch, token);
		return s.run(arg);
	},
	startELearningText: (token: string, arg: IStartELearningTextParam) => {
		const s = ScenarioFactory.createStartELearningText(dispatch, token);
		s.run(arg);
	},

	setNextBtnDisFlg: (nextBtnDisFlg: boolean) =>
		dispatch(setNextBtnDisFlg({ nextBtnDisFlg })),

	pushHistory: (path: string) => dispatch(push(path)),
});

export interface IELearningTextProps extends IELearningCommonProps {
	onChangePlayerStatus: (playing: boolean) => void;
	handleShowIndexTree: () => void;
	handlePrevQuestion: () => void;
	handleNextQuestion: () => void;
	caller: string;
	disabledNext: boolean;
	disabledPrev: boolean;
	setProgressLoadingFlg: (progressLoadingFlg: boolean) => void;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IELearningTextProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ELearningText);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ELearningText.tsx